const pamm = [
	{
		// 产品列表
		path: '/productList',
		name: 'productList',
		component: resolve => require(['@/views/pamm/productList/index'], resolve),
		meta: {
			crumbsOne: 'pamm',
			crumbsTow: 'productList',
			keepAlive: true,
			isPermission: true
		}
	},
	{
		// 产品详情
		path: '/productDetail',
		name: 'productDetail',
		component: resolve =>
			require(['@/views/pamm/productList/productDetail.vue'], resolve),
		meta: {
			crumbsOne: 'pamm',
			crumbsTow: 'productDetail'
		}
	},
	{
		// 投资详情
		path: '/investDetail',
		name: 'investDetail',
		component: resolve =>
			require(['@/views/pamm/productList/productDetail.vue'], resolve),
		meta: {
			crumbsOne: 'pamm',
			crumbsTow: 'investDetail'
		}
	},
	{
		// 我的投资
		path: '/myInvest',
		name: 'myInvest',
		component: resolve => require(['@/views/pamm/myInvest/index2'], resolve),
		meta: {
			crumbsOne: 'pamm',
			crumbsTow: 'myInvest',
			keepAlive: true,
			isPermission: true
		}
	},
	{
		// 投资记录
		path: '/recordList',
		name: 'recordList',
		component: resolve => require(['@/views/pamm/recordList/index'], resolve),
		meta: {
			crumbsOne: 'pamm',
			crumbsTow: 'recordList',
			isPermission: true
		}
	},
	{
		// 我的分成
		path: '/myshare',
		name: 'myshare',
		component: resolve => require(['@/views/pamm/myshare/index'], resolve),
		meta: {
			crumbsOne: 'pamm',
			crumbsTow: 'myshare',
			keepAlive: true,
			isPermission: true
		}
	},
	{
		// 产品管理
		path: '/productManagement',
		name: 'productManagement',
		component: resolve =>
			require(['@/views/pamm/productManagement/index'], resolve),
		meta: {
			crumbsOne: 'pamm',
			crumbsTow: 'productManagement',
			isPermission: true
		}
	},
	{
		// 创建产品
		path: '/createProduct',
		name: 'createProduct',
		component: resolve =>
			require([
				'@/views/pamm/productManagement/component/createProduct'
			], resolve),
		meta: {
			crumbsOne: 'pamm',
			crumbsTow: 'productManagement'
		}
	},
	{
		// 产品管理详情
		path: '/productManagementDetail',
		name: 'productManagementDetail',
		component: resolve =>
			require([
				'@/views/pamm/productManagement/productManagementDetail'
			], resolve),
		meta: {
			crumbsOne: 'pamm',
			crumbsTow: 'productManagementDetail'
		}
	}
]

export default pamm
